import styled from "@emotion/styled";
import { motion } from "framer-motion";
import React from "react";
import { TIMES_SVG } from "../../../utils/svgs";
import { AppIcon } from "../../Generic/AppIcon";
import CachedSignedImage from "./CachedSignedImage";

interface Props {
  isSelected: boolean;
  url: string;
  urlWithoutQuery: string;
  size: number;
  fallback: JSX.Element;
  onSelectImage: (url: string | null) => void;
}

const ChatMessageImageWithPreview = (props: Props) => {
  const handleClickGoBack = () => props.onSelectImage(null);

  const handleClickImage = () => props.onSelectImage(props.urlWithoutQuery);

  return (
    <Container layoutId={`card-container--index-${props.urlWithoutQuery}`} size={props.size}>
      {props.isSelected ? (
        <Back
          onClick={handleClickGoBack}
          initial="initial"
          animate="animate"
          exit="initial"
          transition={{ delay: 0.2, duration: 0.4 }}
          variants={backVariants}
        >
          <AppIcon icon={TIMES_SVG} stroke="currentColor" size={20} />
        </Back>
      ) : null}
      <ImageWrapper
        onClick={handleClickImage}
        isExpanded={props.isSelected}
        layoutId={`card-image--index-${props.urlWithoutQuery}`}
      >
        <CachedSignedImage
          src={props.url}
          width={props.size}
          height={props.size}
          fallback={props.fallback}
        />
      </ImageWrapper>
    </Container>
  );
};

const ImageWrapper = styled(motion.div)<{ isExpanded: boolean }>`
  width: 100%;
  height: 100%;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 12px;
  }

  ${(props) =>
    props.isExpanded
      ? `
        position: fixed;
        z-index: 2;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        img {
          border-radius: 0;
        }
      `
      : null}
`;

const Container = styled(motion.div)<{ size: number }>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

const Back = styled(motion.div)`
  position: fixed;
  top: 4px;
  left: 0px;
  z-index: 3;
  background: white;
  height: 36px;
  width: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px;
`;

const backVariants = {
  initial: {
    opacity: 0,
  },
  animate: { opacity: 1 },
};

export default ChatMessageImageWithPreview;
